import type { UseMutationOptions } from '@tanstack/react-query';

/**
 * Re-shape a generated `xMutation()` (variables = the SDK `Options`: `{ path, query, body }`) to the variables a hook
 * exposes to its callers, so a hook keeps its call signature while the request itself stays the generated one.
 */
export function adaptMutation<TData, TError, TOptions, TVariables>(
  base: UseMutationOptions<TData, TError, TOptions>,
  toOptions: (variables: TVariables) => TOptions,
): UseMutationOptions<TData, TError, TVariables> {
  const { mutationFn, ...rest } = base;
  return {
    ...rest,
    mutationFn: (variables, context) => {
      if (!mutationFn) throw new Error('adaptMutation: the generated mutation has no mutationFn');
      return mutationFn(toOptions(variables), context);
    },
  } as UseMutationOptions<TData, TError, TVariables>;
}
